/**
 * What each DB Manager table tab has TYPED into its WHERE box, keyed by tab id.
 *
 * The box used to be seeded from the committed filter (`tab.filterText`) on
 * every arrival, so text typed but not yet run vanished on a tab switch (owner,
 * 20.10.2026). DataGrip keeps it per tab; so does this.
 *
 * A draft is remembered together with the committed filter it was typed over.
 * When that filter changes from outside the box — a foreign-key jump into the
 * tab, a right-click Filter — the draft is stale and the new filter wins.
 *
 * Module state, not zustand, for the same reason as dbQueryResultCache: it
 * changes on every keystroke and never belongs in a persisted snapshot.
 */

const drafts = new Map(); // tab.id -> { text, base }

export function rememberDbFilterDraft(tabId, text, committed) {
  if (!tabId) return;
  drafts.set(tabId, { text, base: committed || '' });
}

/** The box text for a tab arriving on screen. */
export function dbFilterDraftFor(tab) {
  if (!tab) return '';
  const committed = tab.filterText || '';
  const draft = drafts.get(tab.id);
  return draft && draft.base === committed ? draft.text : committed;
}

export function pruneDbFilterDrafts(keepIds) {
  const keep = keepIds instanceof Set ? keepIds : new Set(keepIds);
  for (const key of [...drafts.keys()]) if (!keep.has(key)) drafts.delete(key);
}

export function clearDbFilterDrafts() {
  drafts.clear();
}
